import React from 'react';
import { HashRouter } from 'react-router-dom';
import { MantineProvider } from '@mantine/core';
import { CustomProvider } from 'rsuite';
import { ContactProvider } from './context/ContactContext';
import { ThemeProvider } from './context/ThemeContext';
import AppRoutes from './AppRoutes';
import ptBR from 'rsuite/locales/pt_BR';

function App() {
  return (
    <MantineProvider
      theme={{
        primaryColor: 'orange',
        colors: {
          orange: [
            '#fff0e4',
            '#ffdfc5',
            '#ffbf88',
            '#ff9c47',
            '#ff7f10',
            '#ff6d00',
            '#ff6300',
            '#e45300',
            '#cb4900',
            '#b13d00',
          ],
        },
      }}
    >
      <CustomProvider locale={ptBR}>
        <ThemeProvider>
          <ContactProvider>
            <HashRouter>
              <AppRoutes />
            </HashRouter>
          </ContactProvider>
        </ThemeProvider>
      </CustomProvider>
    </MantineProvider>
  );
}

export default App;
